import React from "react";

export default function UserMessage({
  content = "",
  timestamp,
}) {
  const time = timestamp
    ? new Date(timestamp).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      })
    : "";

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        marginBottom: 24,
      }}
    >
      <div
        style={{
          maxWidth: 760,
          background: "#0f766e",
          color: "#ffffff",
          borderRadius: 16,
          padding: 18,
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 10,
          }}
        >
          <strong>You</strong>

          <small
            style={{
              opacity: 0.8,
            }}
          >
            {time}
          </small>
        </div>

        <div
          style={{
            whiteSpace: "pre-wrap",
            lineHeight: 1.6,
          }}
        >
          {content}
        </div>
      </div>
    </div>
  );
}